import { HamburgerIcon, StarIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Flex,
  Heading,
  IconButton,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getglobalStoreObject, setState } from "../Stores/globalStore";
import {
  FaArrowCircleLeft,
  FaArrowCircleUp,
  FaHome,
  FaQuestionCircle,
  FaUser,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

function TopNavbar(props) {
  const globalStore = useSelector(getglobalStoreObject);
  const _dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Flex
      w="100%"
      bg="white"
      borderBottom="1px"
      borderColor="gray.200"
      p={4}
      justifyContent={"space-around"}
    >
      {globalStore.isMobile ? (
        <Button
          leftIcon={<HamburgerIcon></HamburgerIcon>}
          onClick={() => {
            props.onLeftSideOpen();
          }}
          border={"1px"}
          borderRight={"4px"}
          borderBottom={"4px"}
          borderColor={"black"}
        >
          Symbols
        </Button>
      ) : (
        <></>
      )}

      {globalStore.centerNavigation == "profile" ? (
        <Link to={"/"}>
          <Button
            rightIcon={<FaHome></FaHome>}
            border={"1px"}
            borderRight={"4px"}
            borderBottom={"4px"}
            borderColor={"blue"}
          >
            Home
          </Button>
        </Link>
      ) : (
        <></>
      )}

      {globalStore.centerNavigation == "symbols" &&
      globalStore.user_profile.userName != "guest" ? (
        <Link to={"/profile"}>
          <Button
            rightIcon={<FaUser></FaUser>}
            border={"1px"}
            borderRight={"4px"}
            borderBottom={"4px"}
            borderColor={"blue"}
          >
            Profile
          </Button>
        </Link>
      ) : (
        <Link to={"/help"}>
          <Button
            rightIcon={<FaQuestionCircle></FaQuestionCircle>}
            border={"1px"}
            borderRight={"4px"}
            borderBottom={"4px"}
            borderColor={"blue"}
          >
            Help
          </Button>
        </Link>
      )}

      <Button
        rightIcon={
          globalStore.user_profile.userName == "guest" ? (
            <FaArrowCircleUp></FaArrowCircleUp>
          ) : (
            <FaArrowCircleLeft></FaArrowCircleLeft>
          )
        }
        border={"1px"}
        borderRight={"4px"}
        borderBottom={"4px"}
        borderColor={"red.500"}
        onClick={() => {
          _dispatch(setState({ user_profile: undefined }));
          localStorage.removeItem("SI_UserName");
          localStorage.removeItem("SI_Password");
          navigate("/login");
        }}
      >
        {globalStore.user_profile.userName == "guest" ? "LogIn" : "LogOut"}
      </Button>

      {/* {globalStore.profile ? (
        <Button onClick={props.onProfileClick}>
          <Box p={1}>
            <Flex flex="1" gap="4" alignItems="center" flexWrap="wrap">
              <Avatar
                name={globalStore.profile.name}
                src={globalStore.profile.imgSrc}
              />

              {globalStore.isMobile ? (
                <></>
              ) : (
                <Box>
                  <Heading size="sm">{globalStore.profile.name}</Heading>
                  <Text></Text>
                </Box>
              )}
            </Flex>
          </Box>
        </Button>
      ) : (
        <></>
      )} */}
    </Flex>
  );
}

export default TopNavbar;
